import { BsCardImage, BsYoutube } from "react-icons/bs";
import { AiFillFacebook } from "react-icons/ai";
import { CiLock, CiUnlock } from "react-icons/ci";

export const SYSTEM_ACCESS = ["amnIbEVWkPUysFt3Kjmr", "rkXsYv8H41SHOM9ZAoky"];

export const USER_GROUPS = [
  {
    name: "Administrator",
    value: "Administrator",
    permissions: ["p0", "c1", "c2", "t1", "n1"],
  },
  {
    name: "Quản trị viên",
    value: "Operator",
    permissions: ["c1"],
  },
];

export const FULL_PERMISSION = ["p0", "c1", "c2", "t1", "n1"];

export const PERMISSION = {
  OPERATOR: "p0",
  CONCEPT: "c1",
  APPROVE: "c2",
  THREE: "t1",
  NEWS: "n1",
};

export const SUB_PERMISSION = {};

export const PERMISSIONS = [
  { id: PERMISSION.OPERATOR, name: "Quản lý quản trị viên" },
  { id: PERMISSION.CONCEPT, name: "Quản lý ý tưởng" },
  { id: PERMISSION.APPROVE, name: "Quản lý xét duyệt" },
  { id: PERMISSION.THREE, name: "Quản lý mô hình 3D" },
  { id: PERMISSION.NEWS, name: "Quản lý tin tức" },
];

export const PERMISSIONS_SUB = [];

export const CONCEPT_TYPE = [
  {
    label: "Vdi media (Ghép bản đồ 3d, tranh ảnh) | vdi-media",
    value: "media",
  },
  {
    label: "Vdi Sport (VDI Fit, Strava) | vdi-sport",
    value: "sport",
  },
];

export const TOP_TYPE = [
  { label: "Kỷ lục thể chất", value: "fitness" },
  { label: "Kỷ lục học đường", value: "education" },
];

export const FOMULAR_SET = [
  {
    label: "Ảnh Facebook",
    value: "facebookPic",
    parent: "media",
    icon: <AiFillFacebook />,
  },
  {
    label: "Video Youtube",
    value: "youtube",
    parent: "media",
    icon: <BsYoutube />,
  },
  {
    label: "Ảnh",
    value: "picture",
    parent: "media",
    icon: <BsCardImage />,
  },
];

// ================================= Bộ concept builder =================================

export const BUILDER_REQUIRE_VALUE = {
  NONE: "none",
  STRAVA: "strava",
};

export const BUILDER_REQUIRE = [
  { label: "Không có", value: BUILDER_REQUIRE_VALUE.NONE },
  { label: "Strava", value: BUILDER_REQUIRE_VALUE.STRAVA },
];

export const BUILDER_INPUT_VALUE = {
  FORM: "form",
  FITNESS: "fitness",
  AVATAR: "avatar",
};

export const BUILDER_INPUT = [
  { label: "Không có", value: "none" },
  { label: "Form", value: BUILDER_INPUT_VALUE.FORM },
  { label: "Fitness", value: BUILDER_INPUT_VALUE.FITNESS },
  { label: "Avatar", value: BUILDER_INPUT_VALUE.AVATAR },
];

export const BUILDER_OUTPUT_VALUE = {
  THREE: "three",
  GOOGLE_MAP: "google map",
  RANKING: "ranking",
};

export const BUILDER_OUTPUT = [
  { label: "Bảng xếp hạng", value: BUILDER_OUTPUT_VALUE.RANKING },
  { label: "3D Three", value: BUILDER_OUTPUT_VALUE.THREE },
  { label: "Google map", value: BUILDER_OUTPUT_VALUE.GOOGLE_MAP },
];

// ================================= Bộ concept action =================================

// =================================  =================================

export const CONCEPT_RECORDS = [{ label: "Kỷ lục thể chất", value: "fitness" }];

export const STATUS = {
  DRAFT: "draft",
  VERIFY: "verify",
  VERIFIED: "verified",
  PRIVATE: "private",
  PUBLISH: "publish",
  PUBLISHED: "published",
  DENY: "deny",
  ACTIVE: "active",
  INACTIVE: "inactive",
  BAN: "ban",
  WAITING: "waiting",
  FAILED: "failed",
  SUCCESS: "success",
};

export const STATUS_VIRTUAL = [
  {
    label: "Momo đang xử lý",
    color: "orange",
    value: "waiting",
  },
  {
    label: "Thất bại",
    color: "red",
    value: "failed",
  },
  {
    label: "Thành công",
    color: "green",
    value: "success",
  },
];

//fitness
export const FIT_VIRTUAL_PRICES = [
  {
    label: "Gói huyền thoại",
    value: "huyenthoai",
    price: 500000,
    content:
      "Thử thách huyền thoại bắt buộc bạn phải hoàn thành trong thời gian ngắn",
  },
  {
    label: "Gói chiến binh",
    value: "chienbinh",
    price: 300000,
    content:
      "Thử thách chiến binh bắt buộc bạn phải chạy thật nhiều cung đường từ thiện",
  },
  {
    label: "Gói khiêu chiến",
    value: "khieuchien",
    price: 100000,
    content:
      "Thử thách chiến binh bắt buộc bạn phải chiến thắng con quỷ trong mình",
  },
];

// ---- type Route
export const TYPE_VIRTUAL_ROUTE = [
  {
    label: "Cung đường thường",
    value: "normal",
    color: "black",
    ribbon: "Normal",
  },
  {
    label: "Cung đường kho báu",
    value: "treasure",
    color: "orange",
    ribbon: "Kho báu",
  },
  {
    label: "Cung đường từ thiện",
    value: "charity",
    color: "red",
    ribbon: "Từ thiện",
  },
  {
    label: "Cung đường câu hỏi",
    value: "quiz",
    color: "green",
    ribbon: "Quiz",
  },
];

export const TOPS_TYPE = {
  FITNESS: "fitness",
  EDUCATION: "education",
};

export const PATH_OPTIONS = {
  virtual: "media",
  treasure: "treasure",
  route: "route",
  story: "story",
};

export const MEDIA_SIZE = [
  {
    value: "200x200",
    label: "200x200",
  },
  {
    value: "400x400",
    label: "400x400",
  },
  {
    value: "680x680",
    label: "680x680",
  },
  {
    value: "1200x1200",
    label: "1200x1200",
  },
  {
    value: "1920x1920",
    label: "1920x1920",
  },
];

export const KEY_WORD_BG = [
  {
    value: "snow-mountain",
    label: "Núi tuyết",
  },
  {
    value: "desert",
    label: "Sa mạc",
  },
  {
    value: "rain-forest",
    label: "Rừng mưa",
  },
  {
    value: "nature",
    label: "Phong cảnh núi đồi",
  },
  {
    value: "humanity",
    label: "Tranh tiến hoá",
  },
  {
    value: "large-mountain",
    label: "Khung cảnh nhiều núi",
  },
  {
    value: "pink-island",
    label: "Đảo màu hồng",
  },
  {
    value: "sunset",
    label: "Hoàng hôn trên sông",
  },
  {
    value: "rowing",
    label: "Hình chèo thuyền trên sông",
  },
  {
    value: "day-vn",
    label: "Ngày 30/4",
  },
  {
    value: "global",
    label: "Hình Toàn cầu",
  },
  {
    value: "cantho",
    label: "Hình Cần Thơ",
  },
];

export const CROSS_SALE = {
  VIRTUAL_FITNESS: "virtual fitness",
};

export const VIRTUAL_TYPES = [
  {
    value: "event",
    label: "Sự kiện",
  },
  {
    value: "training",
    label: "Rèn Luyện",
  },
  {
    value: "wonder",
    label: "Di Sản",
  },
];

export const TIMESTAMP = "DD/MM/YYYY HH:mm:ss";

export const CATEGORIES_SOURCE = [
  {
    label: "VDI GROUP",
    value: "vdigroup",
  },
];

const size = 20;
const color = "black";
export const STATUS_DOCUMENT = [
  {
    value: true,
    label: "Đang khoá",
    icon: <CiLock color={color} size={size} />,
  },
  {
    value: false,
    label: "Có thể tải",
    icon: <CiUnlock color={color} size={size} />,
  },
];

/// ====== COLORS SPEAKER ======== //
export const COLORS_SPEAKER = [
  "#E1EDF5",
  "#DBEAE1",
  "#edc2cf",
  "#edecc2",
  "#cbc2ed",
];

/// ====== JOB STATUS ======== //

export const JOB_STATUS = [
  {
    value: "waiting for deposit",
    label: "Đặt cọc",
    color: "orange",
  },
  {
    value: "waiting for payoff",
    label: "Thanh toán",
    color: "green",
  },
  {
    value: "transcripting",
    label: "AI biên dịch",
    color: "blue",
  },
  {
    value: "supporting",
    label: "AI sửa lỗi",
    color: "purple",
  },
  {
    value: "approval",
    label: "Hoàn tất",
    color: "green",
  },
  {
    value: "ready for download",
    label: "Sẵn sàng để tải",
    color: "green",
  },
];

// STATUS PAYMENT.
export const STATUS_PAYMENT = [
  {
    label: "Tạm giữ",
    value: "waiting",
    color: "orange",
  },
  {
    label: "Kiểm tra",
    value: "verifing",
    color: "blue",
  },

  {
    label: "Đã duyệt",
    value: "verified",
    color: "green",
  },
  {
    label: "Bị huỷ",
    value: "deny",
    color: "red",
  },
];

// STATUS WITHDRAW
export const STATUS_WITHDRAW = [
  {
    label: "Đang chờ duyệt",
    value: "waiting",
    color: "orange",
  },
  {
    label: "Đã trả",
    value: "paid",
    color: "green",
  },
];
